import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, LANGS } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "ciees_lang";

function detectInitial() {
  if (typeof window === "undefined") return "pt";
  const saved = window.localStorage.getItem(STORAGE_KEY);
  if (saved && translations[saved]) return saved;
  const browser = (navigator.language || "pt").slice(0, 2).toLowerCase();
  if (translations[browser]) return browser;
  return "pt";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectInitial);

  const setLang = (code) => {
    if (!translations[code]) return;
    setLangState(code);
    if (typeof window !== "undefined") window.localStorage.setItem(STORAGE_KEY, code);
  };

  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang],
      langs: LANGS,
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
